export default {
  name: "KilaKilaFormCard",
  props: {
    title: {
      type: String,
      require: true
    }
  }
};